// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3yJjB","select":"Header_select__1jSks","clinic":"Header_clinic__3W4am"};